module.exports = __webpack_public_path__ + "build/desktop/img/icon_point_current.e96782038db39a1aa6e49f56532f9252.png";